import { render, staticRenderFns } from "./PayslipList.vue?vue&type=template&id=8723cf88&scoped=true"
import script from "./PayslipList.vue?vue&type=script&lang=js"
export * from "./PayslipList.vue?vue&type=script&lang=js"
import style0 from "./PayslipList.vue?vue&type=style&index=0&id=8723cf88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723cf88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8723cf88')) {
      api.createRecord('8723cf88', component.options)
    } else {
      api.reload('8723cf88', component.options)
    }
    module.hot.accept("./PayslipList.vue?vue&type=template&id=8723cf88&scoped=true", function () {
      api.rerender('8723cf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/PayslipList.vue"
export default component.exports